import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  RAFFLE_ADD_PATH,
  RAFFLE_PATH,
  RAFFLE_UPDATE_PATH,
} from "utils/constants/paths";

const Raffle = Loadable(React.lazy(() => import("./View")));
const RaffleAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const RaffleRoute: IRouteItem = {
  path: RAFFLE_PATH,
  iconName: "Gift",
  element: React.createElement(Raffle),
  name: "Raffle",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: RAFFLE_ADD_PATH,
      element: React.createElement(RaffleAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: RAFFLE_UPDATE_PATH,
      element: React.createElement(RaffleAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
